import { Link, useLocation } from "react-router-dom";
import { Home, Newspaper, Play, Radio, PlusCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useT } from "../../lib/i18n";

const ITEMS = [
  { key: "home", to: "/", icon: Home },
  { key: "articles", to: "/articles", icon: Newspaper },
  { key: "shorts", to: "/shorts", icon: Play },
  { key: "inkwire", to: "/inkwire", icon: Radio },
];

export function MobileNav() {
  const loc = useLocation();
  const { user } = useAuth();
  const { t } = useT();
  const createTo = user ? (user.role === "advertiser" ? "/advertiser" : "/dashboard") : "/login";

  return (
    <nav className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 z-[60] lg:hidden" aria-label="Mobile" data-testid="mobile-bottom-nav">
      <div className="flex justify-around items-center py-2">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const active = loc.pathname === it.to;
          return (
            <Link key={it.to} to={it.to} data-testid={`mobile-nav-${it.key}`}
              className={`flex flex-col items-center gap-0.5 px-3 py-1 text-[10px] font-semibold ${active ? "text-pti-red" : "text-gray-500"}`}>
              <Icon size={22} aria-hidden="true" />
              {t(it.key)}
            </Link>
          );
        })}
        <Link to={createTo} data-testid="mobile-nav-create" className="flex flex-col items-center gap-0.5 px-3 py-1 text-[10px] font-semibold text-pti-red">
          <PlusCircle size={22} aria-hidden="true" />
          {t("create")}
        </Link>
      </div>
    </nav>
  );
}
